/* loaded by smart-asset */
export default require("./assets/pallet.i.svg")